import { useCallback, useState } from "react";

import { BuildTile, StructureName } from "src/api";

import { useGame } from "../../game/GameContext";
import { useSpawnSelection } from "../../game/spawnSelection";
import { useSessionView } from "../../game/useSessionView";
import { Icon } from "../icons/Icon";
import { type StructureIcons } from "../icons/iconTypes";
import { CollapsingCard } from "../shared/CollapsingCard";
import { CollapsingCardMenu } from "../shared/CollapsingCardMenu";
import { ItemTile } from "../shared/ItemTile";
import "./BuildMenu.css";
import { BUILD_CATEGORIES, type BuildCategoryName } from "./buildCategories";
import iconCube from "./icon-cube.png";

const STRUCTURE_ICONS: Record<StructureName, StructureIcons> = {
  store: "structureStore",
  turret: "structureTurret",
  altar: "structureAltar",
  relic: "structureRelic",
  banner: "structureBanner",
  keystone: "structureKeystone",
  well: "structureWell",
  research: "structureResearch"
};

export function BuildMenu() {
  const { session } = useGame();

  const view = useSessionView();
  const buildTiles = view?.hotbar.build ?? [];
  const tileFor = (structure: StructureName) =>
    buildTiles.find((tile) => tile.structure === structure) ?? null;

  const pieceOrStructure = useSpawnSelection((state) => state.pieceOrStructure);
  const selectedStructure =
    pieceOrStructure?.kind === "structure" ? pieceOrStructure.structure : null;

  const [openCategory, setOpenCategory] = useState<BuildCategoryName | null>(
    null
  );

  const onClick = useCallback(
    (structure: StructureName, tile: BuildTile | null) => {
      if (tile) {
        const outcome = session?.choose(tile.option);
        console.log(outcome);
      }
      useSpawnSelection.setState((state) => ({
        pieceOrStructure:
          state.pieceOrStructure?.kind === "structure" &&
          state.pieceOrStructure.structure === structure
            ? null
            : { kind: "structure", structure }
      }));
    },
    [session]
  );

  const icon = <img src={iconCube} alt="" />;

  return (
    <CollapsingCard icon={icon} tooltip={null}>
      <CollapsingCardMenu>
        {BUILD_CATEGORIES.map((category) => (
          <CollapsingCard
            key={category.name}
            icon={
              <Icon icon={category.icon} className="build-menu-category-icon" />
            }
            tooltip={null}
            direction="right"
            open={openCategory === category.name}
            onToggle={() =>
              setOpenCategory((open) =>
                open === category.name ? null : category.name
              )
            }
          >
            <CollapsingCardMenu direction="right">
              {category.structures.map((structure) => {
                const tile = tileFor(structure);
                return (
                  <ItemTile
                    key={structure}
                    icon={STRUCTURE_ICONS[structure]}
                    // TODO: artifact structures have no price, show tokens intead??
                    rows={tile?.rows ?? []}
                    selected={selectedStructure === structure}
                    disabled={tile !== null && tile.reason !== null}
                    onClick={() => onClick(structure, tile)}
                  />
                );
              })}
            </CollapsingCardMenu>
          </CollapsingCard>
        ))}
      </CollapsingCardMenu>
    </CollapsingCard>
  );
}
